import { render, staticRenderFns } from "./operation.vue?vue&type=template&id=84e0a846"
import script from "./operation.vue?vue&type=script&lang=ts"
export * from "./operation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports